import TeamMemberInvite from './container';

export default TeamMemberInvite;
